import React from 'react';
import componentBase from '../../../../../src/lib/component-base';
import ExportsMarketingOption from './children/marketingOption';
import ExportsButtonWrapper from './children/exportsButtonWrapper';
import DataExportsHeader from '../../shared/DataExportsHeader';
import exportTypeIcon from '../../../../../static/images/subscription-icons/List-Icon.svg';
import criteriaIcon from '../../../../../static/images/data-export-icons/Dropdown-Icon-WHITE.svg';
import quoteIcon from '../../../../../static/images/data-export-icons/Invoice-Icon-WHITE.svg';
import purchaseIcon from '../../../../../static/images/credit-card-icon.svg';
import downloadIcon from '../../../../../static/images/data-export-icons/DownloadArrow-Icon-WHITE.svg';

const marketingOptions = [
  {
    icon: exportTypeIcon,
    title: 'Select Export Type',
    text: 'Choose from a variety of historical flight data export options.',
  },
  {
    icon: criteriaIcon,
    title: 'Select Criteria',
    text: 'Select the airports, countries, or regions you are interested in.',
  },
  {
    icon: quoteIcon,
    title: 'Generate A Quote',
    text: 'Quote includes: Number of rows returned and important coverage statistics about the departure and arrival criteria requested.',
  },
  {
    icon: purchaseIcon,
    title: 'Purchase Via Credit Card',
    text: 'To purchase requested data file, simply enter your credit card information.',
  },
  {
    icon: downloadIcon,
    title: 'Download The Data',
    text: 'The data export will take several minutes to generate. Once the export is complete and ready to download you will be notified via email.',
  },
];

@componentBase('NoDataExports')
export default class NoDataExports extends React.Component {
  buttonCallback = (e) => {
    e.preventDefault();
    // go to /new page on btn click
    this.context.goto('/data-exports/new');
  }

  get rows() {
    const rowsToRender = [];
    for (const option of marketingOptions) {
      rowsToRender.push(<ExportsMarketingOption
        icon={option.icon}
        title={option.title}
        text={option.text}
        optionNumber={rowsToRender.length + 1}
        key={rowsToRender.length + 1}
      />);
    }
    return rowsToRender;
  }

  render() {
    // this.logger('props: ', this.props);
    return (
      <div className='no-data-exports'>
        <div className='no-exports-content'>
          <DataExportsHeader primaryText='Data Exports' />
          {this.rows}
          <ExportsButtonWrapper
            buttonCallback={this.buttonCallback.bind(this)}
            buttonLabel='NEW EXPORT'
            prompt='Ready To Generate A New Data Export?'
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/children/NoDataExports.js